var _path, _path2, _path3, _g, _path4, _path5, _g2, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _g3, _path14, _g4, _path15, _g5, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _g6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClaimedRewards(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.1422 29.9011L65.3351 28.6219C67.0528 27.6717 68.6244 27.4889 69.8305 28.1103L72.0234 29.3529L71.1463 29.3895C71.3656 29.7549 71.5118 30.1204 71.6214 30.559C70.196 30.6321 68.8072 30.8879 68.1859 31.8748C68.0397 31.7651 67.8935 31.6555 67.7473 31.5824L65.2985 34.3966L63.1422 33.1905V29.9011Z",
    fill: "url(#paint0_linear_1235:43295)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7075 46.384C64.6446 45.251 66.4354 42.9119 67.2395 40.4267L68.7014 35.9678C69.2131 34.3231 69.14 32.9342 68.4456 32.0936C68.3725 32.0205 68.2994 31.9474 68.2263 31.8743C68.8111 30.9241 70.2365 30.6317 71.6619 30.5586C72.0639 31.984 71.9177 33.8479 71.2964 35.8581L70.1268 39.4764L70.5289 40.0246C70.5289 40.0246 67.7877 46.9688 67.6415 47.0419C67.5319 47.115 66.2892 47.3709 65.4486 47.517C64.608 48.3942 63.6578 49.1252 62.7075 49.6734L55.873 53.6206V56.0694L53.7166 54.8633V51.5739L62.7075 46.384Z",
    fill: "url(#paint1_linear_1235:43295)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8608 47.5912C66.7979 46.4582 68.5888 44.1191 69.3928 41.6338L70.8548 37.1749C71.3299 35.5302 71.2568 34.1414 70.5624 33.3008C69.868 32.4601 68.7715 32.387 67.4923 33.118L65.2994 34.3972V31.1079L67.4923 29.8287C69.7218 28.5495 71.7685 28.6591 72.9746 30.121C74.1807 31.583 74.3269 34.1779 73.4131 37.0287L71.9512 41.4876C70.672 45.4348 67.8943 49.1262 64.8608 50.8805L55.8699 56.0704V52.781L64.8608 47.5912Z",
    fill: "url(#paint2_linear_1235:43295)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter0_f_1235:43295)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.5 90C40.0442 90 34 88.2091 34 86C34 83.7909 40.0442 82 47.5 82C54.9558 82 61 83.7909 61 86C61 88.2091 54.9558 90 47.5 90Z",
    fill: "url(#paint3_linear_1235:43295)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6186 76.6084L38.9445 76.645C39.2003 76.4623 39.4562 76.3161 39.712 76.1699C45.1577 73.0267 54.0024 73.0267 59.4847 76.1699C59.8136 76.3526 60.1426 76.5719 60.435 76.7912L63.5781 76.8277V81.908C63.5781 83.9547 62.2258 86.0379 59.4847 87.6095C54.039 90.7527 45.1943 90.7527 39.712 87.6095C36.9709 86.0379 35.6186 83.9547 35.6186 81.908V76.6084V76.6084Z",
    fill: "url(#paint4_linear_1235:43295)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6166 84.6856C41.9059 84.6856 35.6552 81.0694 35.6552 76.6084C35.6552 72.1475 41.9059 68.5312 49.6166 68.5312C57.3274 68.5312 63.5781 72.1475 63.5781 76.6084C63.5781 81.0694 57.3274 84.6856 49.6166 84.6856Z",
    fill: "url(#paint5_linear_1235:43295)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1235:43295)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.713 82.3096C45.1588 85.4527 54.0035 85.4527 59.4857 82.3096C62.0807 80.8111 63.433 78.874 63.5792 76.9004C63.7253 79.0567 62.3731 81.2497 59.4857 82.9309C54.04 86.0741 45.1953 86.0741 39.713 82.9309C36.8623 81.2862 35.4734 79.0933 35.6196 76.9004C35.7658 78.874 37.1181 80.8111 39.713 82.3096Z",
    fill: "url(#paint6_linear_1235:43295)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.8704 74.4147C42.0532 74.305 42.2359 74.1954 42.4186 74.0492C44.7607 72.683 47.9777 72.1274 51.0313 72.3824C53.136 72.5495 55.1596 73.1128 56.7831 74.0494C57.0388 74.1955 57.258 74.3416 57.4772 74.4878H58.3172V74.488H58.3534V74.4879H59.7422V76.2422C59.7422 77.2651 59.2675 78.2879 58.3547 79.2013V79.2027C57.9161 79.6048 57.4044 80.0068 56.7831 80.3723C56.1009 80.7659 55.348 81.0888 54.5482 81.3445C50.689 82.6084 45.6967 82.2843 42.4186 80.372C40.445 79.239 39.4582 77.7406 39.4582 76.2421V74.3781L41.8704 74.4147Z",
    fill: "url(#paint7_linear_1235:43295)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6183 80.2267C44.027 80.2267 39.4944 77.6086 39.4944 74.379C39.4944 71.1494 44.027 68.5312 49.6183 68.5312C55.2096 68.5312 59.7422 71.1494 59.7422 74.379C59.7422 77.6086 55.2096 80.2267 49.6183 80.2267Z",
    fill: "url(#paint8_linear_1235:43295)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0218 69.5942C52.0248 71.312 47.1639 71.312 44.1669 69.5942C41.17 67.8764 41.17 65.0622 44.1669 63.3079C47.1639 61.5901 52.0248 61.5901 55.0218 63.3079C58.0188 65.0622 58.0188 67.8764 55.0218 69.5942Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5644 70.9088C56.9563 69.7028 57.2487 68.5332 57.2487 68.5332L56.0426 69.9951C52.3147 68.2043 46.869 68.2043 43.1776 69.9951L41.9349 68.5332C41.9349 68.5332 42.2639 69.7028 40.6192 70.9088C39.0111 72.1149 39.5227 74.454 39.5227 74.454C39.5227 75.9525 40.5095 77.4145 42.4832 78.5475C46.3938 80.8135 52.7898 80.8135 56.7005 78.5475C58.6741 77.4145 59.6609 75.916 59.6609 74.454C59.6609 74.454 60.1726 72.1149 58.5644 70.9088Z",
    fill: "url(#paint9_linear_1235:43295)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0218 71.3833C52.0248 73.101 47.1639 73.101 44.1669 71.3833C41.17 69.6655 41.17 66.8512 44.1669 65.0969C47.1639 63.3791 52.0248 63.3791 55.0218 65.0969C58.0188 66.8512 58.0188 69.6289 55.0218 71.3833Z",
    fill: "url(#paint10_linear_1235:43295)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5091 38.3086C29.7284 49.4924 35.4665 50.8447 38.5731 55.0478C41.4604 58.9584 41.1315 64.6234 41.0584 65.3544C41.0584 65.391 41.0584 65.4275 41.0584 65.4275C41.0584 66.7067 41.899 67.9493 43.5437 68.8996C46.8696 70.8367 52.2787 70.8367 55.6047 68.8996C57.1762 67.9859 57.9803 66.8163 58.0899 65.6468H58.1265V65.4275C58.1265 65.391 58.1265 65.391 58.1265 65.3544C58.0534 64.6234 57.7245 58.9584 60.6118 55.0478C63.6818 50.8447 69.4565 49.4924 69.6758 38.3086H29.5091V38.3086Z",
    fill: "url(#paint11_linear_1235:43295)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1697 50.5163C44.1697 50.5163 44.6448 51.8686 46.1067 55.6696C47.5687 59.5072 46.8742 69.1926 46.8742 69.1926L44.389 69.3753C44.0966 69.2291 43.8042 69.1195 43.5483 68.9367C41.8671 67.9865 41.0631 66.7073 41.0631 65.4646C41.0631 65.4281 41.0631 65.3915 41.0631 65.3915C41.1361 64.6606 41.4651 58.9956 38.5778 55.0849C35.5077 50.8818 29.7331 49.5295 29.5138 38.3457H31.7067L44.1697 50.5163Z",
    fill: "url(#paint12_linear_1235:43295)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6093 49.8943C38.5075 49.8943 29.5077 44.7072 29.5077 38.3085C29.5077 31.9098 38.5075 26.7227 49.6093 26.7227C60.7111 26.7227 69.7109 31.9098 69.7109 38.3085C69.7109 44.7072 60.7111 49.8943 49.6093 49.8943Z",
    fill: "url(#paint13_linear_1235:43295)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_1235:43295)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.7904 46.5326C55.9325 51.0646 43.2136 51.0646 35.3923 46.5326C31.7009 44.4128 29.7273 41.6351 29.5445 38.8574C29.3252 42.0006 31.2623 45.1803 35.3923 47.5559C43.2502 52.0879 55.969 52.0879 63.7904 47.5559C67.9203 45.1803 69.894 41.964 69.6381 38.8574C69.4554 41.6351 67.4818 44.3762 63.7904 46.5326Z",
    fill: "url(#paint14_linear_1235:43295)"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M49.616 48.0316C40.3107 48.0316 32.7672 43.679 32.7672 38.3098C32.7672 32.9405 40.3107 28.5879 49.616 28.5879C58.9214 28.5879 66.4648 32.9405 66.4648 38.3098C66.4648 43.679 58.9214 48.0316 49.616 48.0316Z",
    fill: "url(#paint15_linear_1235:43295)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_1235:43295)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.6624 32.3139C44.2411 28.5128 54.9132 28.5128 61.4919 32.3139C64.5985 34.1047 66.2432 36.4073 66.426 38.7464C66.6453 36.1149 65.0006 33.4469 61.4919 31.4367C54.9132 27.6357 44.2411 27.6357 37.6624 31.4367C34.1903 33.4469 32.5456 36.1149 32.7283 38.7464C32.9476 36.4073 34.5923 34.1047 37.6624 32.3139Z",
    fill: "url(#paint16_linear_1235:43295)"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3512 46.7866C46.468 48.4313 52.7543 48.4313 57.8711 46.7866C57.6884 46.6769 57.5056 46.5673 57.3229 46.4576C53.0833 44.0089 46.1756 44.0089 41.8994 46.4576C41.6802 46.5673 41.4974 46.6769 41.3512 46.7866Z",
    fill: "url(#paint17_linear_1235:43295)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_1235:43295)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.1289 65.354C58.1289 65.2809 58.1289 65.0982 58.0924 64.8789C57.9462 66.0485 57.1421 67.1449 55.6436 68.0586C52.3177 69.9957 46.9086 69.9957 43.5827 68.0586C42.0842 67.1815 41.2801 66.085 41.0974 64.952C41.0974 65.1347 41.0974 65.2809 41.0608 65.354C41.0608 65.3906 41.0608 65.4271 41.0608 65.4271C41.0608 66.7063 41.9014 67.949 43.5461 68.8992C46.872 70.8363 52.2812 70.8363 55.6071 68.8992C57.1786 67.9855 57.9827 66.816 58.0924 65.6464H58.1289V65.4271C58.1289 65.4271 58.1289 65.3906 58.1289 65.354Z",
    fill: "url(#paint18_linear_1235:43295)"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5274 63.4139C32.4411 63.9987 33.7569 63.9256 35.1457 63.1215L44.1366 57.9316L46.293 59.1377L45.6716 60.1976L44.1366 60.5997V61.1845L35.1457 66.3743C34.0858 66.9956 33.099 67.3246 32.1487 67.3977C30.833 66.2647 30.9792 64.8027 31.5274 63.4139Z",
    fill: "url(#paint19_linear_1235:43295)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7751 53.5536C27.5009 54.0458 27.2509 54.5561 27.0292 55.08C25.8232 57.9308 25.677 60.6719 26.5907 62.5359L28.0526 65.3136C28.4181 66.008 28.9298 66.5562 29.5145 66.9217L31.6709 68.1278L31.9267 67.4699H32.1826L31.9998 67.2872L32.146 66.8851H31.6709C30.9034 65.8252 31.0861 64.5826 31.5612 63.413C31.1958 63.1572 30.8668 62.8283 30.6475 62.3897L29.1856 59.612C28.9663 59.1369 28.8567 58.5886 28.8567 57.9673L29.5511 58.3694L33.7539 52.3392L33.7542 52.3389L36.7146 49.1592L36.8242 48.3916L34.6679 47.1855L32.475 48.4647C30.6841 49.5246 28.9663 51.3521 27.7602 53.545L27.7751 53.5536Z",
    fill: "url(#paint20_linear_1235:43295)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3021 67.617L46.293 62.4272V59.1378L37.3021 64.3277C35.365 65.4607 33.5741 65.1683 32.7701 63.5967L31.3081 60.819C30.7965 59.7957 30.8696 58.2972 31.564 56.6525C32.2584 55.0444 33.3548 53.6921 34.634 52.9611L36.8269 51.6819V48.3926L34.634 49.6718C32.4046 50.951 30.3579 53.4363 29.1883 56.287C27.9822 59.1378 27.836 61.9155 28.7497 63.7064L30.2117 66.484C31.4543 68.9328 34.2686 69.3714 37.3021 67.617Z",
    fill: "url(#paint21_linear_1235:43295)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.3496 45.2417L40.7466 35.4855L44.5061 33.4539L44.5603 12.0605L52.4865 7.77718L52.4322 29.1706L56.0004 27.2423L59.434 28.8386L48.3496 45.2417Z",
    fill: "url(#paint22_linear_1235:43295)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.7949 46.8335L44.1919 37.0773L59.4458 28.8341L51.7949 46.8335ZM55.8768 30.7617L47.9506 35.045L48.0049 13.651L55.931 9.36769L55.8768 30.7617Z",
    fill: "url(#paint23_linear_1235:43295)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8932 9.39014L52.4977 7.72852L44.5508 12.0632L48.0185 13.6526L55.8932 9.39014Z",
    fill: "url(#paint24_linear_1235:43295)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3064 45.2394L51.7742 46.8287L44.1885 37.0757L40.793 35.4863L48.3064 45.2394Z",
    fill: "url(#paint25_linear_1235:43295)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_1235:43295)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.793 14.0879H48.0454L48.1296 33.2737L47.8771 33.2663L47.793 14.0879Z",
    fill: "url(#paint26_linear_1235:43295)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1235:43295",
    x: 26,
    y: 74,
    width: 43,
    height: 24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_1235:43295"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1235:43295",
    x: 34.6094,
    y: 75.9004,
    width: 29.9805,
    height: 10.3887,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_1235:43295"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1235:43295",
    x: 28.5273,
    y: 37.8574,
    width: 42.1328,
    height: 14.0977,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_1235:43295"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_1235:43295",
    x: 31.7148,
    y: 27.5859,
    width: 35.7305,
    height: 12.1602,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_1235:43295"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_1235:43295",
    x: 40.0625,
    y: 63.8789,
    width: 19.0664,
    height: 7.47266,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_1235:43295"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_1235:43295",
    x: 47.293,
    y: 13.5879,
    width: 1.33594,
    height: 20.1855,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_1235:43295"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1235:43295",
    x1: 68.6439,
    y1: 32.3437,
    x2: 62.7767,
    y2: 28.6254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B28DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463542,
    stopColor: "#9665FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#725BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1235:43295",
    x1: 69.5941,
    y1: 54.1942,
    x2: 46.2872,
    y2: 42.971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#321DB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269097,
    stopColor: "#30266F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57118,
    stopColor: "#4E3FAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#422977"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1235:43295",
    x1: 71.7158,
    y1: 54.0763,
    x2: 47.9211,
    y2: 43.3231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#321DB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269097,
    stopColor: "#5742D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57118,
    stopColor: "#725BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#825DCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1235:43295",
    x1: 51.6088,
    y1: 88.4566,
    x2: 50.5372,
    y2: 84.6104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E18BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302693,
    stopColor: "#725BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9665FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1235:43295",
    x1: 60.0503,
    y1: 88.7795,
    x2: 41.4029,
    y2: 66.9594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#321DB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269097,
    stopColor: "#5742D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57118,
    stopColor: "#725BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#825DCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1235:43295",
    x1: 52.9528,
    y1: 79.6976,
    x2: 37.4933,
    y2: 67.0201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B28DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463542,
    stopColor: "#9665FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#725BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1235:43295",
    x1: 49.5995,
    y1: 76.9004,
    x2: 49.5995,
    y2: 85.2883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1235:43295",
    x1: 57.1829,
    y1: 81.3803,
    x2: 46.3821,
    y2: 66.2303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#321DB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269097,
    stopColor: "#5742D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57118,
    stopColor: "#725BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#825DCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1235:43295",
    x1: 57.1874,
    y1: 79.3671,
    x2: 43.6876,
    y2: 63.566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#321DB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269097,
    stopColor: "#5742D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57118,
    stopColor: "#725BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#825DCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1235:43295",
    x1: 57.1778,
    y1: 79.386,
    x2: 43.6583,
    y2: 63.5513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#321DB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269097,
    stopColor: "#5742D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57118,
    stopColor: "#725BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#825DCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1235:43295",
    x1: 51.4284,
    y1: 69.9349,
    x2: 42.9434,
    y2: 62.9629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B28DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463542,
    stopColor: "#9665FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#725BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1235:43295",
    x1: 64.6077,
    y1: 67.9971,
    x2: 27.6684,
    y2: 36.6923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#321DB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269097,
    stopColor: "#5742D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57118,
    stopColor: "#725BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#825DCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1235:43295",
    x1: 40.3703,
    y1: 59.7942,
    x2: 25.2296,
    y2: 55.7372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B28DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463542,
    stopColor: "#9665FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#725BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1235:43295",
    x1: 55.7273,
    y1: 45.424,
    x2: 50.6983,
    y2: 36.1445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E18BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302693,
    stopColor: "#725BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9665FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1235:43295",
    x1: 49.594,
    y1: 38.8574,
    x2: 49.594,
    y2: 50.9549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1235:43295",
    x1: 62.213,
    y1: 46.6025,
    x2: 39.7734,
    y2: 20.3097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#321DB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269097,
    stopColor: "#5742D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57118,
    stopColor: "#725BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#825DCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1235:43295",
    x1: 49.58,
    y1: 28.5859,
    x2: 49.58,
    y2: 38.7464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1235:43295",
    x1: 55.7867,
    y1: 47.7703,
    x2: 53.574,
    y2: 40.4995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#321DB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269097,
    stopColor: "#5742D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57118,
    stopColor: "#725BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#825DCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1235:43295",
    x1: 49.5949,
    y1: 64.8789,
    x2: 49.5949,
    y2: 70.352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1235:43295",
    x1: 44.3795,
    y1: 66.7019,
    x2: 33.3526,
    y2: 54.7582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33219E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269097,
    stopColor: "#3220A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57118,
    stopColor: "#4E3DB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#825DCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1235:43295",
    x1: 32.7053,
    y1: 61.6614,
    x2: 23.2509,
    y2: 59.343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463542,
    stopColor: "#B795FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#725BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1235:43295",
    x1: 44.0049,
    y1: 67.1903,
    x2: 23.015,
    y2: 54.5067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#321DB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269097,
    stopColor: "#5742D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57118,
    stopColor: "#725BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#825DCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1235:43295",
    x1: 52.2783,
    y1: 36.0081,
    x2: 42.5844,
    y2: 19.8945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC2A33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484541,
    stopColor: "#FF4B55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF777F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1235:43295",
    x1: 54.7791,
    y1: 37.0129,
    x2: 47.9685,
    y2: 26.6665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF757D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9358,
    stopColor: "#FF4B55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1235:43295",
    x1: 52.1365,
    y1: 8.6677,
    x2: 49.0703,
    y2: 33.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0677083,
    stopColor: "#FFDADC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401042,
    stopColor: "#FF4B55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9358,
    stopColor: "#FF4B55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1235:43295",
    x1: 48.4217,
    y1: 38.1288,
    x2: 48.1706,
    y2: 42.8909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C71A24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9358,
    stopColor: "#ED2A35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1235:43295",
    x1: 47.9593,
    y1: 14.4252,
    x2: 47.9593,
    y2: 32.2648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5FFFF",
    stopOpacity: 0.029658
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2375,
    stopColor: "#E5FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5FFFF",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimedRewards);
export default __webpack_public_path__ + "static/media/claimed-rewards.4e66cd15.svg";
export { ForwardRef as ReactComponent };